<template>
  <section class="help">
    <com-tabs
      :list="tabsList"
      class="help-tabs"
      :default-tab="activeTab"
      @change="changeTab"
    >
      <template v-slot:text="{ obj }">
        <div
          :class="{ activeTab: activeTab == obj.key }"
          class="help-tabs-item"
        >
          <span>
            <img
              :src="require(`@/assets/dto/dto-help${obj.key + 1}.png`)"
              alt=""
            >
          </span>
          <span>{{ obj.name }}</span>
        </div>
      </template>
    </com-tabs>

    <div v-loading.fullscreen.lock="loading" class="help-content">
      <div class="help-title">
        常 见 问 题
      </div>
      <!-- <div v-for="(tabsItem, tabsIndex) in tabsList" :key="tabsIndex">
        <div v-show="activeTab == tabsIndex" class="help-content-tab"> -->
      <div class="help-floor1">
        <el-input
          v-model="requestParams.title"
          :placeholder="conditionTitle"
          clearable
        />
        <el-button type="text" @click="handleSubmit(requestParams)">
          <i class="el-icon-search" />
        </el-button>
      </div>
      <div class="panelBox">
        <div
          v-for="(tableItem, tableIndex) in tableData"
          :key="tableIndex"
          class="panel-item"
          @click="handleRouteDto(tableItem.id)"
        >
          <span class="itemTitle">{{ tableItem.title }}</span>
          <span class="item-date">发布时间: {{ tableItem.created_date }}</span>
        </div>
      </div>
      <div>
        <el-pagination
          class="fun-pagination"
          :current-page="requestParams.page"
          :page-sizes="[10, 50, 100, 500]"
          :page-size="requestParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <!-- </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import comTabs from '@/components/comTabs'
export default {
  components: { comTabs },
  data() {
    return {
      tabsList: [],
      tableData: [],
      total: null,
      activeTab: 0,
      requestParams: {
        page: 1,
        page_size: 10,
        title: ''
      },
      loading: false,
      helpInfo: mock.notes.help.viewInfo,
      helpInit: mock.notes.help.init
    }
  },
  computed: {
    conditionTitle() {
      return `共有${this.total}个问题`
    }
  },
  created() {
    this.loading = true
    this.init(this.requestParams)
  },
  mounted() {},
  methods: {
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    async initType() {
      this.tabsList = await this.helpInit.types()
      this.requestParams.type = this.tabsList[0].id
      this.init(this.requestParams)
    },
    async init(v) {
      const obj = await this.helpInit.data1(v)
      this.tableData = obj.data
      this.total = obj.total
      this.loading = false
    },
    changeTab(x, y) {
      this.activeTab = x
      this.requestParams.type = y
      this.init(this.requestParams)
    },
    handleSubmit() {
      this.init(this.requestParams)
    },
    handleSizeChange(val) {
      this.requestParams.page_size = val
      this.init(this.requestParams)
    },
    handleCurrentChange(val) {
      this.requestParams.page = val
      this.init(this.requestParams)
    },
    handleRouteDto(v) {
      this.$router.push({
        path: `/help/details`,
        query: {
          id: v
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.fun-pagination{
  @include fun-pagination(32px,left);
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.help {
   background-color: #fff;
  border-radius: 10px;
  margin-top: 50px;
  padding-bottom: 50px;
  height:100%;
  max-height: 800px;
  position: relative;
  overflow: hidden;
  padding-top:20px;
  width: $xr-min-width;
  &-title{
    text-align: center;
    color: #333;
    font-size: 26px;
    font-weight: bold;
  }
  &-floor1{
    display: none;
  }
  &-tabs {
    &-item {
      width: 100%;
      margin-right: 48px;
      padding: 16px 0;
      background-color: #fff;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      &:nth-child(5) {
        margin-right: 0;
      }
      > span {
        font-family: "AdobeHeitiStd-Regular";
        @include fun-design(5);
        > img {
          width: 50px;
          height: 50px;
        }
      }
    }
    .activeTab {
      @include fun-active(2);
    }
  }
  &-content {
     height:100%;
  max-height: 800px;
    &-tab {
      > div {
        &:nth-child(1) {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          > div {
            &:nth-child(1) {
              margin-top: 56px;
              margin-bottom: 50px;
              width: 56%;
              display: flex;
              > button {
                @include fun-design(4);
                width: 100px;
              }
            }
          }
          > button {
            width: 100px;
          }
        }
        &:nth-child(2) {
          > div {
            padding-top: 16px;
            height: 90px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            @include fun-border(0,"bottom");
            cursor: pointer;
            > span {
              &:nth-child(1) {
                display: flex;
                align-items: center;
                width: 80%;
                > span {
                  &:nth-child(1) {
                    width: 6px;
                    height: 6px;
                    background-color: #a9a9a9;
                    margin-left: 9px;
                  }
                  &:nth-child(2) {
                    margin-left: 20px;
                    font-family: "AdobeHeitiStd-Regular";
                    width: 80%;
                    @include fun-design(8);
                    @include obj-clamp1()
                  }
                }
              }
              &:nth-child(2) {
                flex: 1;
                font-family: "AdobeHeitiStd-Regular";
                font-size: 14px;
                color: #f5f9fd;
                margin-right: 16px;
                text-align: right;
              }
            }
          }
        }
        &:nth-child(3) {
          text-align: right;
          padding-bottom: 100px;
        }
      }
    }
  }
}
.panelBox{
  padding: 20px;
  height: 100%;
  padding-bottom: 40px;
  overflow-y: auto;
}
.panel-item{
  line-height: 30px;
  font-size: 16px;
  color: #555;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  border-bottom: 1px solid #eee;
  padding: 6px 0;
  .item-date{
    width: 200px;
    flex-shrink: 0;
    margin-left: 25px;
  }
  .itemTitle{
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

  }
}
.panel-item:hover{
  color: #2f82ff;
}
</style>
